module.exports = __webpack_public_path__ + "img/logo.416f38cb.png";